import { supabase } from './supabase';

const REVIEW_FIELDS = 'id,order_id,reviewer_id,reviewee_id,rating,comment,created_at';

export async function getProfileReputations(profileIds) {
  const ids = [...new Set((profileIds || []).filter(Boolean))];
  if (!supabase || ids.length === 0) return { data: [], error: null };
  const batches = [];
  for (let index = 0; index < ids.length; index += 100) batches.push(ids.slice(index, index + 100));
  const results = await Promise.all(batches.map(p_profile_ids => (
    supabase.rpc('get_profile_reputations', { p_profile_ids })
  )));
  const failed = results.find(result => result.error);
  return failed || { data: results.flatMap(result => result.data || []), error: null };
}

export async function getReviewsForOrders(orderIds) {
  const ids = [...new Set((orderIds || []).filter(Boolean))];
  if (!supabase || ids.length === 0) return { handoffs: [], reviews: [], error: null };

  const [handoffResult, reviewResult] = await Promise.all([
    supabase.from('cash_handoffs').select('order_id,status').in('order_id', ids),
    supabase.from('transaction_reviews').select(REVIEW_FIELDS).in('order_id', ids).order('created_at'),
  ]);

  return {
    handoffs: handoffResult.data || [],
    reviews: reviewResult.data || [],
    error: handoffResult.error || reviewResult.error || null,
  };
}

export async function getReviewsForProfile(profileId) {
  if (!supabase || !profileId) return { data: [], error: null };
  return supabase
    .from('transaction_reviews')
    .select(REVIEW_FIELDS)
    .eq('reviewee_id', profileId)
    .order('created_at', { ascending: false })
    .limit(50);
}

export async function getMyReviewReports(reviewIds) {
  const ids = [...new Set((reviewIds || []).filter(Boolean))];
  if (!supabase || ids.length === 0) return { data: [], error: null };
  return supabase
    .from('transaction_review_reports')
    .select('id,review_id,category,details,status,created_at,updated_at')
    .in('review_id', ids);
}

export async function submitOrderReview(orderId, rating, comment) {
  if (!supabase) return { data: null, error: new Error('Review submission is unavailable in demo mode.') };
  return supabase.rpc('submit_transaction_review', {
    p_order_id: orderId,
    p_rating: rating,
    p_comment: comment,
  });
}

export async function submitTransactionReviewReport(reviewId, category, details) {
  if (!supabase) return { data: null, error: new Error('Review reporting is unavailable in demo mode.') };
  return supabase.rpc('submit_transaction_review_report', {
    p_review_id: reviewId,
    p_category: category,
    p_details: details || null,
  });
}
